import { render, staticRenderFns } from "./approvers-table.vue?vue&type=template&id=070c0b02&"
import script from "./approvers-table.vue?vue&type=script&lang=js&"
export * from "./approvers-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports